import React from 'react';

interface SettingsSectionHeadingProps {
  title: string;
  description?: React.ReactNode;
}

/** h3-level section break inside a SettingsPanel — use it to group rows
 *  by sub-topic (e.g. "Display name", "Email", "Password" inside an
 *  Account panel). Optional description shows under the heading. */
export const SettingsSectionHeading: React.FC<SettingsSectionHeadingProps> = ({
  title,
  description,
}) => (
  <header className="kx-settings-section-heading">
    <h3>{title}</h3>
    {description && <p>{description}</p>}
  </header>
);

export default SettingsSectionHeading;
